import type { NoteTarget } from '@shared/flow/notes';
import type { SignalRow } from '@shared/flow/signal-view';

/**
 * A signal's Notes target: its contact when it has one, else its account;
 * neither means there is nothing to note on (`null`). Shared by the Signal
 * card's "Save as note" and the Signals table's row bubble.
 */
export function signalNoteTarget(row: Pick<SignalRow, 'contact_id' | 'account_id'>): NoteTarget | null {
  if (row.contact_id) return { kind: 'contact', id: row.contact_id, accountId: row.account_id };
  if (row.account_id) return { kind: 'account', id: row.account_id, accountId: row.account_id };
  return null;
}
